export default __webpack_public_path__ + "static/media/mainLogo.f5c05791.png";